import Vue from "vue";
import axios from "axios";
const baseUrl = '/wp-json/wp/v2'
Vue.prototype.$eventHub = new Vue();


document
  .querySelectorAll('.vue-partners')
  .forEach((el) => {
  new Vue({
    delimiters: ["[[", "]]"],
    async asyncData({ params, $http }) {
      const partners = await $http.$get(`${baseUrl}/partners`);
      return { partners };
    },
    el,
    data() {
      return {
        searchQuery: '',
        filters: {
          page: 1,
          per_page: 18,
          orderby:'menu_order',
          order : 'desc'
        },
        partners: [],
        current_partner_id: 1,
        partner_type: [],
        totalPages: null,
      };
    },    
    created() {
      this.getPartners();
    },
    mounted(){
      this.getTypes();
    },
    computed: {      
      orderPartnerType() {
        return this.partner_type.sort((a, b) => a.id - b.id);
      },
      hasMore() {
        return this.totalPages > this.partners.length;
      },
    },
    methods: {  
      classClickable(partner){
        return {
          'cursor-pointer' : partner.content.rendered,
          'pointer-events-none' : !partner.content.rendered,
        }
      },  
      openModal (partner) {
        if(!partner.content.rendered) {          
          return
        }
        this.current_partner_id = partner.id
        this.$eventHub.$emit('modal:partner:open', partner.id)
      },  
      getPartners(more = false) {
        if (this.filters.partner_type === "") {
          delete this.filters.partner_type;
        }
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/partners`,
            params: this.filters,
            headers: { 'content-type': 'application/json' },
          })
          .then((response) => {
            this.partners = (more)? this.partners.concat(response.data) : response.data
            this.totalPages = response.headers["x-wp-total"];
          })
          .catch((error) => {
            this.errors = Object.assign(this.errors, error.response.data);
          });
      },      
      getTypes() {
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/partner_type`,
            params: {
              per_page: 8,
            },
          })
          .then((response) => {
            this.partner_type = this.deleteEmptyCategories(response.data)
          });
      },
      deleteEmptyCategories(cat) {
        return cat.filter((el) => el.count != 0)
      },
      getMorePartners() {
        this.filters.page++;
        this.getPartners(true);
      },    
      updateSearch(e){
        this.filters.search = this.searchQuery
        this.getPartners();
      },
      updateType(type) {
        if (type) {
          this.filters.page = 1
          this.filters.partner_type = type;
          delete this.filters.search;
          this.searchQuery = null
        } else {
          delete this.filters.partner_type;
        }
        this.getPartners();
      }
    },
  });
})
